module.exports = __webpack_public_path__ + "img/domaintypejt.9951c100.png";